import { useCallback, useEffect, useMemo, useState } from 'react'
import { Spinner } from 'reactstrap'

import ScreenContainer from 'components/ScreenContainer'
import { EVENT_TYPE, STRING } from 'resources'
import { sendAnalyticsEvent } from 'services/analytics'

import { fetchJackpotPrizes, fetchJackpotPledge } from 'config/consumerApiAxiosInstance'
import JackpotScreenHeader from './ScreenHeader'
import JackpotAmountSelector from './JackpotAmountSelector'
import { CenterContainer, JackpotContainer, JackpotContent, ErrorMessage } from './styles'

const Jackpot = () => {
  const [isFetching, setIsFetching] = useState(true)
  const [fetchError, setFetchError] = useState(false)
  const [data, setData] = useState({})

  const fetchData = useCallback(async () => {
    try {
      const pledgeData = await fetchJackpotPledge()
      const prizeData = await fetchJackpotPrizes()
      setData({ ...pledgeData, ...prizeData })
      setFetchError(false)
    } catch {
      setFetchError(true)
    }
  }, [])

  useEffect(() => {
    const initialFetch = async () => {
      setIsFetching(true)
      await fetchData()
      setIsFetching(false)
    }

    sendAnalyticsEvent(EVENT_TYPE.jackpotShow)
    initialFetch()
  }, [fetchData])

  const currentPledge = Number(data?.amount ?? 0).toFixed(2) || '0.00'
  const currentPrize = data?.currentPrize || '0.00'
  const numPrizes = data?.numPrizes || 1

  const content = useMemo(() => {
    if (fetchError) {
      return (
        <CenterContainer>
          <ErrorMessage>{STRING.jackpot.getDataErrorMessage}</ErrorMessage>
        </CenterContainer>
      )
    }
    if (isFetching) {
      return (
        <CenterContainer>
          <Spinner />
        </CenterContainer>
      )
    }
    return <JackpotAmountSelector currentPledge={currentPledge} numPrizes={numPrizes} fetchData={fetchData} />
  }, [fetchError, isFetching, currentPledge, numPrizes, fetchData])

  return (
    <>
      <JackpotScreenHeader isFetching={isFetching} currentPrize={currentPrize} numPrizes={numPrizes} />
      <ScreenContainer removePaddingTop>
        <JackpotContainer>
          <JackpotContent>{content}</JackpotContent>
        </JackpotContainer>
      </ScreenContainer>
    </>
  )
}

export default Jackpot
